import { useEffect, useState } from 'react'
import { CSSTransition } from 'react-transition-group'

import { Icon, Text } from 'components'

import styles from './Snackbar.module.scss'

export interface ToastProps {
  isVisible: boolean
  error?: boolean
  autohideTimeout?: number
  message: string
}

export function Toast(props: ToastProps) {
  const { message, isVisible, error, autohideTimeout = 0 } = props
  const [showToast, setShowToast] = useState(false)

  useEffect(() => {
    setShowToast(isVisible)
  }, [isVisible])

  useEffect(() => {
    if (autohideTimeout) {
      const timer = setTimeout(() => {
        setShowToast(false)
      }, autohideTimeout)
      return () => clearTimeout(timer)
    }
  }, [autohideTimeout, isVisible])

  return (
    <CSSTransition
      in={showToast}
      timeout={{ enter: 400, exit: 100 }}
      classNames={{
        enter: styles['slide-in-enter'],
        enterActive: styles['slide-in-enter-active'],
        exit: styles['slide-in-exit'],
        exitActive: styles['slide-in-exit-active'],
      }}
      unmountOnExit
    >
      <div
        role={error ? 'alert' : 'status'}
        className={`${styles.toast} ${error ? styles['--error'] : ''}`}
      >
        <Icon
          color="element-inverse"
          name={error ? 'error' : 'success'}
          className={styles['toast-icon']}
        />

        <Text size="sm" color="element-inverse">
          {message}
        </Text>
      </div>
    </CSSTransition>
  )
}

export default Toast
